<template>
	<div id="giftExperience">
		<div class="position-relative">
			<div class="row-grid" id="scroller1">
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
            <div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/hebergement-unique.webp" alt="DES HÉBERGEMENTS UNIQUES" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">DES HÉBERGEMENTS UNIQUES</p>
              <p class="raleway-reg-p15">Sélectionnés pour leur charme, leur confort et leur engagement environnemental.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/engagement-durable.webp" alt="Un engagement durable" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2 text-uppercase">Un engagement durable</p>
              <p class="raleway-reg-p15">Un cadeau responsable, conçu dans les moindres détails pour durer.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/double-experience.webp" alt="Un coffret cadeau à double facette" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2 text-uppercase">Un coffret cadeau à double facette</p>
              <p class="raleway-reg-p15">Un cadeau responsable qui mêle l’inspiration d’un guide de voyage à l’émotion d’un séjour éco-responsable.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/liberte-totale.webp" alt="UNE LIBERTÉ TOTALE" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UNE LIBERTÉ TOTALE</p>
              <p class="raleway-reg-p15">Accès à tout le catalogue Hortense, sans contrainte de lieu ni de date.</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/experience-enrichie.webp" alt="UNE EXPÉRIENCE ENRICHIE" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2">UNE EXPÉRIENCE ENRICHIE</p>
              <p class="raleway-reg-p15">Chaque coffret inclut 1 privilège exclusif au cours du séjour (massage, surclassement, dîner…)</p>
            </div>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/guide-voyage-2.webp" alt="UN GUIDE DE VOYAGE PERSONNALISÉ" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2 text-uppercase">Un guide de voyage</p>
              <p class="raleway-reg-p15">Conseils et idées pour voyager autrement, de façon plus responsable.</p>
            </div>
					</div>
				</div>
        <div class="col-hub">
					<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
						<div class="zoom-img-container">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/accompagnement-sur-mesure.webp" alt="UN ACCOMPAGNEMENT SUR MESURE" class="zoom-img">
            </div>
            <div class="d-flex flex-column align-items-start">
              <p class="raleway-bold-p16 mt-2 mb-2 text-uppercase">UN ACCOMPAGNEMENT SUR MESURE</p>
              <p class="raleway-reg-p15">Conciergerie dédiée pour organiser un séjour parfaitement adapté aux envies du bénéficiaire.</p>
            </div>
					</div>
				</div>
			</div>
      <div class="flex-shrink-0 previous-slide-button circle-icon" @click="scroll_left" v-if="!isPhone">
				<img src="../../images/arrow-left.svg" alt="Previous" />
			</div>
			<div class="flex-shrink-0 next-slide-button circle-icon" @click="scroll_right" v-if="!isPhone">
				<img src="../../images/arrow-right.svg" alt="Next" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'ExceptionalEntrepriseExperience',
  data() {
    return {
      isPhone: window.innerWidth <= 768,
    }
  },
  methods: {
    goToGroup(url){
      window.open(url, '_blank');
    },
    scroll_left() {
      let content = document.querySelector("#scroller1");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      console.log('here')
      let content = document.querySelector("#scroller1");
      content.scrollLeft += 220;
    }
  },
};
</script>

<style scoped lang="scss">

#giftExperience {
	padding-top: 70px;
  @media screen and (max-width: 767px) {
    padding-top: 10px;
  }

	.row-grid {
		display: flex;
		gap: 20px;
    overflow-x: auto;
    overflow-y: hidden;

    @media screen and (max-width: 767px) {
      gap: 12px;  
    }
	}

	.col-hub {
		flex: 0 0 18%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.card-hub {
		position: relative;
		width: 100%;
	}

	.card-hub img {
		width: 100%;
		height: 400px;
		object-fit: cover;

    @media screen and (max-width: 767px) {
      width: 306px;
      height: 398px;
    }
	}

	.col-hub:nth-child(odd) .card-hub {
		transform: translateY(-15px);
	}

	.col-hub:nth-child(even) .card-hub {
		transform: translateY(15px);
	}
}
#scroller1 {
	overflow-x: scroll !important;
}

.circle-icon {
	width: 35px;
	height: 35px;
	border: 1px solid #000000B1;
	background: #000000B1 0% 0% no-repeat padding-box;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	img {
		width: 20px;
	}
}

.previous-slide-button {
	position: absolute;
	top: 50%;
	left: 3%;
	transform: translateY(-50%);
	color: white;

	@media screen and (max-width: 767px) {
		left: 0;
	}
}

.next-slide-button {
	position: absolute;
	top: 50%;
	right: 3%;
	transform: translateY(-50%);
	color: white;

	@media screen and (max-width: 767px) {
		right: 0;
	}
}
</style>
